'use client';

import { c as _c } from "react/compiler-runtime";
import { Globe, Mail } from 'lucide-react';

// Marketing footer shared by the logged-out homepage (via About.tsx) and
// /about. It SSRs, so the link list doubles as internal-link discovery for
// crawlers — /waitlist was a sitemap-only orphan with zero inbound links
// before this. The © year is inlined at build time (next.config `env`): a
// `new Date()` during render, even in a client component, postponed the whole
// page into the streamed Suspense hole under Cache Components, so nothing of
// the marketing page was in the prerendered HTML.
const MarketingFooter = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-6"><h3 className="text-2xl font-semibold text-textPrimary">Factiii</h3><p className="mt-4 text-lg text-textSecondary">The Internet's Truth Layer. Discover, verify, and share facts while keeping your privacy.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="mb-4 text-lg font-semibold text-textPrimary">Contact Info</h4>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-3"><Mail className="size-5 text-primary" /><a href="mailto:support@factiii.com" className="text-textSecondary transition-colors hover:text-primary">support@factiii.com</a></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="lg:col-span-2">{t0}<div className="mb-8">{t1}<div className="space-y-3">{t2}<div className="flex items-center gap-3"><Globe className="size-5 text-primary" /><span className="text-textSecondary">factiii.com</span></div></div></div></div>;
    t4 = <h4 className="mb-6 text-lg font-semibold text-textPrimary">Company</h4>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div>{t4}<ul className="space-y-4"><li><a href="/about" className="text-textSecondary transition-colors hover:text-primary">About</a></li><li><a href="/contact" className="text-textSecondary transition-colors hover:text-primary">Contact</a></li><li><a href="mailto:support@factiii.com" className="text-textSecondary transition-colors hover:text-primary">Support</a></li><li><a href="/waitlist" className="text-textSecondary transition-colors hover:text-primary">Get Early Access</a></li></ul></div>;
    t6 = <h4 className="mb-6 text-lg font-semibold text-textPrimary">Explore</h4>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="grid gap-12 lg:grid-cols-4">{t3}{t5}<div>{t6}<ul className="space-y-4"><li><a href="/explore" className="text-textSecondary transition-colors hover:text-primary">Explore</a></li><li><a href="/trending" className="text-textSecondary transition-colors hover:text-primary">Trending</a></li><li><a href="/spaces" className="text-textSecondary transition-colors hover:text-primary">Spaces</a></li></ul></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-textSecondary">© {process.env.NEXT_PUBLIC_BUILD_YEAR} Factiii. All rights reserved.</p>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <footer className="border-t border-ds-border-standard bg-background-primary"><div className="mx-auto max-w-7xl px-6 py-16">{t7}<div className="mt-16 border-t border-ds-border-standard pt-8"><div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between"><div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-8">{t8}<div className="flex gap-6"><a href="/privacy" className="text-textSecondary transition-colors hover:text-primary">Privacy Policy</a><a href="/terms" className="text-textSecondary transition-colors hover:text-primary">Terms of Service</a><a href="/cookies" className="text-textSecondary transition-colors hover:text-primary">Cookie Policy</a></div></div><p className="text-textSecondary">Humanity • Privacy • Transparency</p></div></div></div></footer>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};
export default MarketingFooter;